import PostFilter from "../../components/post-filter";

export default class PageModule {
	constructor() {
		this.initPostFilter();
	}

	initPostFilter() {
		const postFilter = new PostFilter();
	}
}